import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { Grid, InputLabel, Link, Box, Typography, Accordion, AccordionDetails, AccordionSummary, Modal } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AddIcon from '@mui/icons-material/AddCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Button from '../../../components/Button';
import { useCourse } from '../hooks';
import { Section } from '../../../components/course/lessonPlan/Section';
import { generateUUID } from '../../../utils';
import CreateIcon from '@mui/icons-material/Create';
import { getLessonPlan } from '../../../store/course/courseSlice';
import { getAllWithoutPage } from '../../../store/course/courseBaseApi';
import Loader from '../../../components/Loader';
import { NoLessonPlan } from '../../../components/course/lessonPlan/NoLessonPlan';


export const EditLessonPlan = () => {

    const { courseId } = useParams();
    const navigate = useNavigate();
    const { loadLessonPlan, lessonPlan, createLessonPlan, updateLessonPlan, deleteLessonPlan, loadCurrent, current, loading, saveLessonPlan } = useCourse();
    const [assessments, setAssessments] = useState();
    const [editEnable, setEditEnable] = useState(false);
    const [isCreate, setIsCreate] = useState(false);
    const [lessonPlanData, setLessonPlanData] = useState();
    const [openConfirm, setOpenConfirm] = useState(false);
    const [assessmentPath, setAssessmentPath] = useState()
    const [type, setType] = useState()

    useEffect(() => {
        if (courseId) {
            loadCurrent({ id: courseId });
        }
    }, [courseId]);

    useEffect(() => {
        if (courseId) {
            loadLessonPlan({ id: courseId });
        }
    }, [courseId]);

    useEffect(() => {
        const url = window.location.pathname;
        const lastPart = url.substring(url.lastIndexOf('/') + 1);
        setType(lastPart)
    }, [])
    useEffect(() => {
        if (lessonPlan?.id) {
            setLessonPlanData(lessonPlan)
            setIsCreate(true)
        }
    }, [lessonPlan])

    React.useEffect(() => {
        if (lessonPlan?.assessments) {
            setAssessments(lessonPlan?.assessments);
        }
    }, [lessonPlan]);

    const addSection = () => {
        let sections = (lessonPlan?.sections || []).map(e => e);
        let section = {
            name: '',
            chapters: [],
            sequence: 1,
            assessments: [],
            description: '',
            prerequistes: [],
            thumbnailUrl: '',
            sectionId: generateUUID()
        }

        if (sections.length) {
            section.sequence = (sections.length + 1);
        }

        section.name = 'Chapter ' + section.sequence;

        sections.push(section);
        updateLessonPlan({ sections });
    }

    const onCreate = () => {
        let params = {
            courseId: courseId,
        }, body = { lessonPlan, status: 'ACTIVE' }; //Hardcoding status as of now

        createLessonPlan({ params, body });
        navigate(`/courses/${courseId}/lesson-plan`)
    }

    const onDelete = () => {
        if (!confirm('Are you sure to delete lesson plan?')) { return; }
        deleteLessonPlan({ courseId: courseId, id: lessonPlan.id })
    }

    const onUpdate = () => {

        let body = {

            status: lessonPlan?.status || 'ACTIVE',
            lessonPlan: {
                sections: lessonPlan?.sections
            }
        }
        // setEditEnable(false)
        saveLessonPlan({ body, lessonPlanId: lessonPlan.id })
        // navigate(`/courses/${id}/lesson-plan`)
    }

    const cancelChanges = () => {
        // setEditEnable(false)
        updateLessonPlan(lessonPlanData)
        // loadLessonPlan({ id });
        // loadCurrent({ id });
        // navigate(`/courses/${id}/lesson-plan`)
        setIsCreate(!isCreate)
    }

    const handleAssessmentClick = (path) => {
        if (editEnable) {
            setOpenConfirm(true)
            setAssessmentPath(path)
        } else {
            navigate(path)
        }
    };

    const confirmClick = (conformation) => {
        if (conformation) {
            navigate(assessmentPath)
        }
        setOpenConfirm(false)
    }

    return (
        <>
            {loading ?
                <Loader /> :
                <>
                    <Box
                        sx={{
                            padding: '0px',
                            maxWidth: '100%',
                        }}>
                        <div className='course'>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <Typography
                                    align="left"
                                    variant="h1"
                                    color="primary.blue"
                                    sx={{
                                        margin: '0',
                                        fontWeight: '700',
                                        lineHeight: '1.5',
                                        fontSize: '1.8rem',
                                    }}>{(lessonPlan?.id) ? 'Edit' : 'Create'} Lesson Plan - ({current?.courseName})</Typography>
                                {lessonPlan && lessonPlan.id &&
                                    <div style={styles.action}>
                                        <Link onClick={onDelete} title="Delete lesson plan" sx={{ color: 'var(--mui-palette-primary-blue)', cursor: 'pointer' }}>
                                            <DeleteIcon />
                                        </Link>

                                    </div>
                                }
                            </Box>

                        </div>
                        {isCreate ?
                            <>
                                <Grid spacing={2} alignItems="center">
                                    <Grid item xs={12} sx={{
                                        p: '8px 10px !important',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        background: 'var(--mui-palette-primary-blue)',
                                        borderRadius: '5px',
                                        my: 2
                                    }}>
                                        <InputLabel
                                            sx={{
                                                color: 'var(--mui-palette-common-white)',
                                                fontSize: '22px',
                                                fontWeight: '500',
                                            }}
                                        >Courses</InputLabel>

                                        <Button sx={{ p: 0, color: 'var(--mui-palette-common-white)', minWidth: '30px' }} onClick={() => addSection()} placeholder={
                                            <Link title="Add Chapter" sx={{ color: 'var(--mui-palette-primary-contrastText)' }}><AddIcon /> </Link>} variant='text' />
                                    </Grid>

                                    <Grid style={{ width: '100%' }} item>
                                        {lessonPlan.sections && lessonPlan.sections.map((item, i) => <Section data={item} key={item.sectionId || i} handleAssessmentClick={handleAssessmentClick} />)}
                                    </Grid>

                                </Grid>
                            </> :
                            <>
                                <NoLessonPlan setIsCreate={setIsCreate} />
                            </>
                        }
                    </Box>
                    {/* {!editEnable && lessonPlan.id &&
                        <Box sx={{
                            padding: '0px',
                            maxWidth: '100%',
                            mt: 2
                        }}>
                            <Grid spacing={2} alignItems="center">
                                <Grid item xs={12} >
                                    <Accordion sx={{
                                        boxShadow: 'none',
                                        border: '1px solid var(--mui-palette-gray-lightGray50)',
                                        borderRadius: '4px',
                                    }} >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={{
                                                background: 'var(--mui-palette-gray-lightGray50)',
                                                boxShadow: 'none',
                                                borderRadius: '4px',
                                                minHeight: '48px !important',
                                                '& .Mui-expanded': {
                                                    margin: '12px 0 !important',
                                                }
                                            }}
                                        ><Box sx={{ color: 'var(--mui-palette-primary-blue)', width: '80%', fontWeight: 'bold' }}>Course Assessments</Box>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {assessments?.map((assessment, i) => {
                                                return (
                                                    <Box key={assessment?.id} sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        background: 'var(--mui-palette-gray-lightGray50)',
                                                        alignItems: 'center',
                                                        p: 1,
                                                        mt: 2,
                                                        borderRadius: '5px',
                                                    }}>{assessment?.name}

                                                        <div style={styles.actionBtn} >
                                                           <Link style={styles.assessmentsLink} component={RouterLink} to={`lesson-plan/${lessonPlan.id}/assessments/edit/${assessment?.id}`} title="Edit Assessment"> <CreateIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} /></Link>
                                                            <Button sx={{ color: 'var(--mui-palette-primary-blue)', p: 0 }} variant='text' onClick={() => removeAssessment(assessment)} placeholder={<DeleteIcon />} />
                                                        </div>
                                                    </Box>
                                                )
                                            })}
                                            {!assessments?.length > 0 &&
                                                   <Link style={styles.assessmentsLink} component={RouterLink} to={`lesson-plan/${lessonPlan.id}/assessments/create`}>Create Assessment <ArrowForwardIcon sx={{ ml: 1 }} /></Link>}
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                            <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
                                <Box
                                    sx={styles.modalContainer}
                                >
                                    <Typography variant="h4" component="h2">
                                        <WarningAmberIcon sx={{ color: 'yellow', }} fontSize='15' />{' Warning!'}
                                    </Typography>
                                    <Typography sx={{ mt: 2 }}>
                                        {'Your change are not taken are you sure to move the assessment'}
                                    </Typography>
                                    <Button variant="outlined" sx={{ mr: 2, mt: 3 }} onClick={() => confirmClick(false)} placeholder={'No'} />
                                    <Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={() => confirmClick(true)} placeholder={'Yes'} />
                                </Box>
                            </Modal>
                        </Box>
                    } */}
                    {isCreate && <Grid container spacing={2} sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                        <Grid item xs={12} md={6}>
                            {lessonPlan?.id &&
                                <span style={{ color: 'grey', fontSize: '0.8em' }}>(Make sure to click "<span style={{ color: '#000', fontWeight: '600' }}>Save Changes</span>" before leaving this page to avoid losing any updates )</span>
                            }

                        </Grid>
                        <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {!lessonPlan.id && <Button onClick={() => cancelChanges()} variant='outlined' placeholder={'Cancel'} sx={{ mr: 2 }} />}
                            {lessonPlan?.id && <Button size='large' onClick={() => navigate('/courses')} variant='outlined' placeholder={'Back'} sx={{ mr: 2 }} />}
                            {!lessonPlan.id ?
                                <Button onClick={onCreate} variant="contained" color="primary" placeholder={'Create'} disabled={!lessonPlan?.sections?.length > 0} />
                                :
                                <Button onClick={onUpdate} variant="contained" color="primary" placeholder={'Save Changes'} />
                            }
                        </Grid>
                    </Grid>
                    }
                </>
            }
        </>
    );
};

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    assessmentsLink: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center'
    },
    action: {
        display: 'flex',
        gap: '10px  '
    },

    modalContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        textAlign: 'center'
    }
}